module.exports = __webpack_public_path__ + "img/barcode.f1d76957.svg";